import { render, staticRenderFns } from "./store.vue?vue&type=template&id=2b2cb724&scoped=true&"
import script from "./store.vue?vue&type=script&lang=ts&"
export * from "./store.vue?vue&type=script&lang=ts&"
import style0 from "./store.vue?vue&type=style&index=0&lang=less&"
import style1 from "./store.vue?vue&type=style&index=1&id=2b2cb724&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2cb724",
  null
  
)

export default component.exports